const blockChainActionTypes = {
	MEMBER_BLOCK_CHAIN_LOAN_APPROVAL_START: 'MEMBER_BLOCK_CHAIN_LOAN_APPROVAL_START',
	MEMBER_BLOCK_CHAIN_LOAN_APPROVAL_SUCCESS: 'MEMBER_BLOCK_CHAIN_LOAN_APPROVAL_SUCCESS',
	MEMBER_BLOCK_CHAIN_LOAN_APPROVAL_FAILURE: 'MEMBER_BLOCK_CHAIN_LOAN_APPROVAL_FAILURE',
	MEMBER_BLOCK_CHAIN_LOAN_APPROVAL_CHANGED: 'MEMBER_BLOCK_CHAIN_LOAN_APPROVAL_CHANGED',
	MEMBER_BLOCK_CHAIN_LOAN_APPROVAL_RESET: 'MEMBER_BLOCK_CHAIN_LOAN_APPROVAL_RESET',
};
export default blockChainActionTypes;
